import React from "react";

const Appcard = ({ phone_number, is_registered }) => {
  const registered = is_registered === "Y";
  const formattedNumber = phone_number
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");

  const bgClass = registered ? "bg-yellow-300" : "bg-neutral-200";

  return (
    <div className="flex flex-col items-center">
      <div
        className={`
          ${bgClass}
          mt-[3vh] mb-[1.5vh] h-[15vh] w-[60vw] rounded-xl shadow
          flex items-center justify-center
        `}
        aria-label={registered ? "설정 완료된 카드" : "미설정 카드"}
      >
        {registered ? (
          <span className="text-[5.5vw] font-extrabold">{formattedNumber}</span>
        ) : (
          <span className="text-red-400 font-bold text-[3.5vw]">미설정</span>
        )}
      </div>

      {registered && (
        <div className="text-[4vw] mb-[10vw] font-bold text-black">
          설정완료
        </div>
      )}
    </div>
  );
};

export default Appcard;
